import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import logoDark from '../ShiftyPM_Logo_Dark.svg';
import logoLight from '../ShiftyPM_Logo_Light.svg';

/** Wordmark for current theme (`ShiftyPM_Logo_Dark` / `ShiftyPM_Logo_Light`). */
export default function AppBrandLogo({ maxWidth = 280, sx = {}, ...rest }) {
  const theme = useTheme();
  const logoSrc = theme.palette.mode === 'dark' ? logoDark : logoLight;

  return (
    <Box
      component="img"
      src={logoSrc}
      alt="Shifty PM"
      sx={{
        width: '100%',
        maxWidth,
        height: 'auto',
        display: 'block',
        objectFit: 'contain',
        ...sx,
      }}
      {...rest}
    />
  );
}
